export enum TransactionDetails {
  TRANSACTION_DATE = 'Transaction Date',
  TRANSACTION_DETAILS = 'Transaction Details',
  TRANSACTION_TYPE = 'Transaction Type',
  PAID_WITH_POINTS = 'Paid With Points',
  CUSTOMER_NAME = 'Customer Name',
  TRANSACTION_AMOUNT = 'Transaction Amount',
  WALLET_BALANCE = 'Wallet Balance',
  TRANSACTION_DESCRIPTION = 'Transaction Description',
  TRANSACTION_DATE_TIME = 'Transaction Date & Time',
  TRANSACTION_ID = 'Transaction ID',
  ITEM_AMOUNT = 'Item Amount',
  TAX = 'Tax',
  AMOUNT_DEBITED_FROM_WALLET = 'AMOUNT DEBITED FROM WALLET',
  AMOUNT_PAID_FROM_WALLET = 'Amount Paid by Wallet',
  TIP = 'Tip',
  TIP_TO = 'Tip to',
  TIP_BY = 'Tip by',
  EARNING = 'earning',
  EARNING_CAPS = 'Earning',
  PURCHASES = 'purchases',
  GROSS_AMOUNT = 'Gross Amount',
  THIRD_PARTY_PROCESSING_FEE = '3rd Party Processing Fees',
  TOPFANS_REVENUE_SHARE = 'TopFan Revenue Share',
  DEPOSIT_AMOUNT = 'Deposit Amount',
  WITHDRAWL_AMOUNT = 'Withdrawal Amount',
  PROCESSING_FEE_DEDUCTION = 'Processing Fee Deduction',
  ADDED_TO_WALLET = 'Added to Wallet',
  DEPOSIT = 'Deposit',
  DOWNLOAD_CSV = 'Download CSV',
  BY_WALLET = 'By wallet = ',
  BY_CREDIT_CARD = 'By Credit Card = ',
  BY_BANK = 'By Bank = ',
  VIEW = 'view',
  PENDING_SMALL_CAPS = 'pending',
  FAILED_SMALL_CAPS = 'failed',
  FAILED = 'Failed',
  PENDING = 'Pending',
  COMPLETED = 'Completed',
  TRANSACTION_TYPE_EARNING = 'Earning',
  TRANSACTION_TYPE_PURCHASE = 'Purchase',
  TRANSACTION_TYPE_DEPOSIT = 'Deposit',
  REFUND = 'refund',
  TRANSACTION_TYPE_REFUND_RECIEVED = 'Refund received',
  TRANSACTION_TYPE_REFUND_DEDUCTED = 'Refund deducted',
  REFUND_REQUEST_REASON = 'Refund Request Reason',
  FAN_REFUND_RECIEVED = 'Refund Received',
  FAN_REFUND_ISSUED = 'Fan Refund Issued',
  TRANSACTION_TYPE_WITHDRAWAL = 'Withdrawal',
  PURCHASED_FROM = 'Purchased from',
  PURCHASED_BY = 'Purchased by',
  PAYMENT_DETAILS = 'Payment Details',
  DETAILS = 'Details',
  ITEM_CHARGES = 'Item Charges',
  TOTAL_PRICE = 'TOTAL PRICE',
  AMOUNT_DEDUCTED_FROM_WALLET = 'Amount Deducted From Wallet',
  AMOUNT_CREDITED_TO_WALLET = 'AMOUNT CREDITED TO WALLET',
  CHARGES_PER_MONTH = 'Charges per month',
  DISCOUNT = 'Discount ',
  TRANSACTION_TYPE_REFERRAL = 'Referral Commission',
  REFERRAL = 'Referral',
  SHIPPING_CHARGES = 'Shipping Charges',
  MONTH = ' Month',
  STARTS_FROM = 'Starts from ',
  USERS = ' Users',
  COST_TO_SEND_EMAIL = 'Cost to send email per user',
  COST_TO_SEND_SMS = 'Cost to send SMS per user',
  AMOUNT_IN_SETTLEMENT_PERIOD = 'AMOUNT IN SETTLEMENT PERIOD',
  AMOUNT_TO_BE_CREDITED = 'AMOUNT TO BE CREDITED',
  AMOUNT_FAN_WAS_CHARGED = 'AMOUNT FAN WAS CHARGED',
  POINTS_CHARGED = 'Points Charged',
  ON_HOLD = 'on_hold',
  DEFAULT_TITLE = 'Default Title',
  CHARGEBACK = 'Chargeback',
  MESSAGE_AUDIO = 'Message Audio',
  PURCHASE = 'Purchase',
  CREDIT = 'Credit',
  DEDUCTION = 'Deduction',
  MANUAL_WALLET = 'Manual Wallet',
  SUBSCRIPTION = 'Subscription',
  SMS = 'SMS',
  EMAIL = 'Email',
  EMAIL_MARKETING = 'Email Marketing',
  EVENT_TICKET = 'Event Ticket',
  MONTHY_PRICE = '% Off Monthly Price)',
  DELEGATOR_EARNING = 'Delegator Earning',
  DELEGATOR_PAYMENT = 'Delegator Payment',
  REVENUE_EARNED_BY_YOU = 'Revenue Earned By You',
  DELEGATE_WALLET_CREDIT = "Amount Credited to Delegate's Wallet",
  REVENUE_EARNED_BY_CREATOR = 'Revenue Earned By Creator',
  DELEGATOR_SHARE_REVENUE = 'Delegator Share Revenue',
  VIP_OFFER = 'VIP Offer',
  DELEGATOR_REVENUE_SHARE = 'Delegate Revenue Share',
  DELEGATE = 'Delelgate',
  EARNING_CAP = 'Earning',
  DELEGATION_REFUND_ISSUED = 'Delegation Refund Issued',
  DELEGATION_REFUND_RECEIVED= 'Delegation Refund Received',
  DELEGATION_REFUND = 'Delegate Refund',
  DM_POST = 'DM POST',
  DM_CONTENT = 'DM Content',
  MESSAGE_CONTENT_EARNING = 'Message Content Earning',
  DM_UNLOCK_CREDIT = 'Sent Direct Message',
  DIRECT_MESSAGE_CONTENT = 'Direct Message Content',
  PURCHASE_DETAILS = 'Purchase Details',
  PURCHASE_FROM = 'Purchase From',
  ORDER_ID = 'Order ID',
  CANCELLED = 'Canceled',
  MERCHANDISE = 'Merchandise',
  SHIPPING = 'Shipping',
  SUCCESS = 'success',
  MESSAGE_CONTENT='Message Content',
  WITHDRAWAL_PROCESSING_FEES= '($0.25 + 0.25%)',
  INTERNATIONAL_PROCESSING_FEES = 'International Processing Fees',
  WITHDRAWAL_PROCESSING_FEES_PERCENTAGE = '(1%)',
  AMOUNT_CREDITED_TO_BANK = 'AMOUNT CREDITED TO BANK',
  WITHDRAWAL_CURRENCY_EXCHANGE_FEE = 'For withdrawals in currencies other than USD, a 1% foreign exchange (forex) markup may be applied by our third-party payment processor.',
  LIVE_STREAM = 'Livestream',
  UNLOCK_CREDIT = 'Unlock Credit',
  MESSAGE_UNLOCK_CREDIT = 'Message Unlock Credit',
  RECEIVED_PAID_DIRECT_MESSAGE = 'Received Paid Direct Message',
  PAID_MESSAGE_EARNING = 'Paid Message Earning',
  PAID_DIRECT_MESSAGE = 'Paid Direct Message',
  ADVERTISEMENT = 'Advertisement',
  BRAND = 'Brand',
  PAYMENT_RECEIVED = 'Payment Received',
  VIEW_DETAILS = 'View Details',
  PAYMENT_DETAIL_HINT = 'Your credit card was charged in US Dollars, so the local currency conversion may show a slight difference on your credit card statement.',
  BUYPOINTS = "BUYPOINTS",
  POINTS = "POINTS",
  POST_TIP = "Post Tip",
  POST_UNLOCK = "Post Unlock",
  VIEW_TICKET = 'View Ticket',
  EVENT_CALENDAR = 'EVENT_CALENDAR',
}

export enum TransactionFor {
  EMAIL = 'email',
  SMS = 'sms',
  TRANSACTION_TYPE_REFERRAL = 'Referral'
}
